<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Locations"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'locations.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('locations', 'create')">New Location</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('locations', 'view')">
                <app-table v-if="locations.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Location
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                ResponseTap Number
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(l, i) in locations" :key="i">
                            <app-table-cell>
                                {{ l.name }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                {{ l.responsetap_number }}
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'locations.edit', params: { id: l.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('locations', 'edit')">
                                    <app-icon icon="edit" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = l.id" v-if="checkPermission('locations', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="locations"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>


            <div class="flex flex-wrap -mx-2 mt-8">
              <div class="w-full md:w-1/2 px-2">
                <!-- Start Title -->
                <app-title
                  title="Live Locations"
                />
                <!-- End Title -->
              </div>
              <div class="w-full md:w-1/2 px-2">
                <app-button element="a" class="btn  btn--primary  btn--primary--sml float-right" @click="save">
                    Save
                </app-button>
              </div>
            </div>

          <app-box :loading="loading" :initial="loading" v-if="checkPermission('locations', 'view')">
            <app-table v-if="allLocations.length > 0">
              <app-table-header>
                <app-table-row :header="true">
                  <app-table-cell :header="true">
                    Location
                  </app-table-cell>
                  <app-table-cell :header="true">
                    Telephone Override (careful of ResponseTap)
                  </app-table-cell>
                  <app-table-cell class="text-center" :header="true">
                    Is live?
                  </app-table-cell>
                </app-table-row>
              </app-table-header>

              <app-table-body>
                <app-table-row v-for="(l, i) in allLocations" :key="i">
                  <app-table-cell>
                    {{ l.name }}
                  </app-table-cell>
                  <app-table-cell>
                    <app-field-text
                      v-model="l.telephone_override"
                    />
                  </app-table-cell>
                  <app-table-cell class="text-center">
                    <app-field-toggle
                      :required="false"
                      v-model="l.is_live"
                    />
                  </app-table-cell>
                </app-table-row>
              </app-table-body>
            </app-table>

            <app-button element="a" class="btn  btn--primary  btn--primary--sml mt-6" @click="save">
              Save
            </app-button>
          </app-box>



        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a location. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextField from '@/components/fields/inputs/Text';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'locations.home',

        data: () => ({
            loading: true,
            locations: [],
            allLocations: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal,
            'app-field-toggle': ToggleField,
            'app-field-text': TextField,
        },

        mounted() {
            this.getLocations()
                .then(response => {
                    this.loading = false;
                });
        },

        methods: {
            getLocations() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                return Api.request('get', `locations?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.locations = data.locations.data;
                        this.allLocations = data.allLocations;
                        this.response = data;
                    });
            },
            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteLocations( this.confirmModalId ).then(response => {
                        return this.getLocations();
                    }).then(response => {
                        this.loading = false;
                        this.confirmModalId = false;
                    });
            },
            deleteLocations(id) {
                return Api.request('get', `locations/delete/${id}`);
            },
            save() {
              const data = this.allLocations.map( item => {
                return { id: item.id, live: item.is_live ? 1 : 0, telephone_override: item.telephone_override };
              } );

              return Api.request('post', `locations/live`, { locations: data })
                .then( data => {
                  this.$toasted.show(data.data.message, {
                    type: "success",
                    position: "bottom-right",
                    duration : 5000
                  });
                } );
            }
        },

        computed: {
            ...mapGetters({

            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/locations/Home.vue